var map = {
	"./20200703_135933.jpg": 889,
	"./20210331_092217.jpg": 196,
	"./20210916_121258.jpg": 340,
	"./20220216_104412.jpg": 313,
	"./20221025_101042.jpg": 219,
	"./20251021_094729.jpg": 381,
	"./20260115_140545.jpg": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 814;